import { z } from "zod";
import { passwordSchema } from "./passwordValidator";

export const createClienteIntermedioWithUserSchema = z.object({
  usuario: z.object({
    nombreUsuario: z.string().min(2),
    correo: z.string().email(),
    contrasena: passwordSchema,
    nombre: z.string().min(2),
    apellidoPaterno: z.string().min(2),
    apellidoMaterno: z.string().optional(),
    idRol: z.literal(2),
  }),
  cliente: z.object({
    nombreEmpresa: z.string().min(2),
  }),
});

export type CreateClienteIntermedioWithUserInput = z.infer<
  typeof createClienteIntermedioWithUserSchema
>;
